<script setup lang="ts">
import { CompromissoForm } from '~/lib/fw';

interface Props {
  pastaCodigos?: string[];
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);
</script>

<template>
  <CompromissoForm
    action="adiciona-pasta-base-ativa/adicionar-pasta-base-ativa"
    :pasta-codigos="props.pastaCodigos ?? []"
    :wait-for-result="true"
    :show-upload-files="false"
    @close="() => emit('close')"
  >
    <template #form>
      <a-alert
        type="info"
        message="Você irá adicionar as pastas selecionadas a base ativa"
        show-icon
        style="margin-bottom: 24px"
      />
    </template>
  </CompromissoForm>
</template>
